// @ts-nocheck
import React, { Component } from 'react';
import { observer, inject } from "../../stores/mobx-compat";

import PageHeader from '../ui/PageHeader';
import Tabs from '../ui/Tabs';
import PaymentSetup from './PaymentSetup';
import AccountDetails from './AccountDetails';
import CapturePlansUpgrade from './PaymentSetup/CapturePlansUpgrade';

class Payments extends Component {
  state = { active: 'account' };

  componentDidMount() {
    const { accountStatus, payments } = this.props.store;
    if (!accountStatus.account || Object.keys(accountStatus.account).length === 0) {
      accountStatus.getAccountDetails();
    }
    if (!payments.availablePlans || payments.availablePlans.length === 0) {
      payments.getAvailablePlans();
    }
  }

  get items() {
    const { account } = this.props.store.accountStatus;
    if (account && account.subscriptions && account.subscriptions.data && account.subscriptions.data.length > 0) {
      return [
        { value: 'account', label: 'Account details' },
        { value: 'upgrade', label: 'Upgrade plan' },
      ];
    }
    return [{ value: 'plans', label: 'Capture plans' }];
  }

  render() {
    const items = this.items;
    const active = items.find((i) => i.value === this.state.active) ? this.state.active : items[0].value;
    return (
      <>
        <PageHeader
          eyebrow="Payments"
          title={<>Your <em>plan</em>, your billing.</>}
          sub="Manage your subscription and payment method."
        />
        <Tabs
          value={active}
          onChange={(v) => this.setState({ active: v })}
          items={items}
        />
        {active === 'account' && <AccountDetails />}
        {active === 'upgrade' && <CapturePlansUpgrade />}
        {active === 'plans' && <PaymentSetup />}
      </>
    );
  }
}

export default inject('store')(observer(Payments));
